import { Injectable, inject } from '@angular/core'
import { UiDialogService } from './ui-dialog.service'

@Injectable({
	providedIn: 'root'
})
export class AlertService {
	private uiDialogService = inject(UiDialogService)

	// Método para abrir el alert, se le pasa por parámetro la cadena que queramos que se muestre
	async openAlert(alertMessage: string, title: string = 'DIALOG_ALERT_TITLE') {
		await this.uiDialogService.openAlert(alertMessage, {
			title,
			primaryLabel: 'ACCEPT',
			showCloseButton: true
		})
	}

	async openInfoAlert(alertMessage: string) {
		await this.openAlert(alertMessage, 'INFORMATION')
	}
}
